import React, { Component } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import PullToRefresh from 'antd-mobile/lib/pull-to-refresh'
import context from '../../context'
import { getRewardDetail } from '@/components/poizon-fission/apis'

interface IState {
  pageNum: number
  isFinish: boolean
  list: any
}
class Rewards extends Component<any, IState> {
  static contextType = context
  refreshing: boolean
  constructor(props) {
    super(props)
    this.state = {
      pageNum: 1,
      isFinish: false,
      list: [],
    }
    this.refreshing = false
    this.load = this.load.bind(this)
  }

  componentDidMount() {
    this.load()
  }

  async load() {
    this.refreshing = true
    const { pageNum, isFinish, list } = this.state
    if (isFinish) {
      return
    }
    const { lang, local, activityType } = this.context
    const { code, data } = await getRewardDetail({
      pageNum: pageNum,
      pageSize: 10,
      countryCode: local,
      language: lang,
      activityType,
    })
    this.refreshing = false
    if (code !== 200) {
      return
    }
    const nextPageNum = this.state.pageNum + 1
    this.setState({
      pageNum: nextPageNum,
      isFinish: nextPageNum > data?.pages,
      list: data?.contents ? list.concat(data.contents) : list,
    })
  }

  render() {
    const {
      rewardDetail: { cols, empty },
    } = this.context
    const { list } = this.state
    const show = list && list.length

    return (
      <section className={styles.rewards}>
        <h3 className={styles.header}>
          {cols.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </h3>
        <div className={classnames(styles.list, { [styles.hidden]: !show })}>
          <PullToRefresh
            style={{
              height: 222,
              overflow: 'auto',
            }}
            getScrollContainer={() => ''}
            damping={60}
            distanceToRefresh={20}
            indicator={{
              activate: ' ',
              deactivate: ' ',
              finish: ' ',
            }}
            direction="up"
            refreshing={this.refreshing}
            onRefresh={this.load}
          >
            {list.map(
              ({ subsidyTime, subsidyNodeDesc, subsidyTypeDesc, currencySymbol, subsidyAmt }) => (
                <>
                  <div key={subsidyTime} className={styles.item}>
                    <span>{subsidyTime}</span>
                    <span>{subsidyNodeDesc}</span>
                    <span>{subsidyTypeDesc}</span>
                    <span>{`${currencySymbol} ${subsidyAmt}`}</span>
                  </div>
                </>
              )
            )}
          </PullToRefresh>
        </div>
        <div className={classnames(styles.empty, { [styles.hidden]: show })}>{empty}</div>
      </section>
    )
  }
}

export default Rewards
